import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { DemoService } from '../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Router } from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';


import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, DataUtil } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import { IFilter } from '@syncfusion/ej2-angular-grids';
import {
  GridComponent, ToolbarItems, GroupSettingsModel,
  RowDataBoundEventArgs
} from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';

import { BsModalRef, BsModalService, TabsetComponent } from 'ngx-bootstrap';


import {GlobalFunctionsService} from './../../services/global-functions.service';
import { CompanyEditComponent } from './../../admin/companies-home/company-edit/company-edit.component';

@Component({
  selector: 'app-client-jobs',
  templateUrl: './client-jobs.component.html',
  styleUrls: ['./client-jobs.component.css']
})
export class ClientJobsComponent implements OnInit {
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  sessionUserLevel: any;
  sessionUserFullName: string;
  sessionUserName: any;

  brand: any;
  brand_id: number;
  brandUsers: any;
  brandUsersCount: any;
  brand_type: Object;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  // Switches for show hide things
  addTraceCandidate = false;
  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
  baseUploadURL: string;
  nav: any;
  // end tabs


  // Grid Vars
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 };
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  user_level: Object;
  get_access_level: any;
  sessionUserFirstName: any;
  sessionUsername: any;
  all_router_details: string;
  current_base_route: string;


  constructor(
    private http: HttpClient, private router: Router, private route: ActivatedRoute, private _demoService: DemoService,
    public datepipe: DatePipe, private _location: Location,
    private modalService: BsModalService,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    public gfunc: GlobalFunctionsService
  ) {

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));

    this.nav = document.querySelector('nav.navbar');

    this.nav.className += ' white-bg';
    // this.brand_id = +this.route.snapshot.paramMap.get('brand_id');
    this.brand_id = this.gfunc.sessionBrandId;
    this.baseUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/'  + this.brand_id; // no trailing slash
  }

  ngOnInit() {
    this.getBrandById(this.brand_id);
    this.getBrandUsers(this.brand_id);
    this.getBrandJobsTableData(this.brand_id);
    // Grid Options
    this.toolbarOptions = ['ExcelExport', 'Search', 'PdfExport'];
    this.initialPage = { pageSize: 20 };
    this.filterOptions = {
      type: 'Menu'
    };
    this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
    this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };
    this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' }] };


    // end date filter options
    // End Grid Options
  }


  getBrandById(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      data => {
        this.brand = data;
        const res = data[0];
        this.getBrandType(res.brand_type_id);
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );

  }


  getBrandUsers(brand_id) {
    this._demoService.getBrandUsers(brand_id)
      .subscribe(
        data => {
          this.brandUsers = data;
         let res = data[0];
          this.get_access_level = res.access_level;
          this.brandUsersCount = this.brandUsers.length;
          this.getFormUserLevel(this.get_access_level);


        },
        err => console.error(err),
        //  () =>  console.log('loading L')
      );
  }

  getBrandType(brand_type_id) {
    this._demoService.getBrandBrandType(brand_type_id).subscribe(
      data => { this.brand_type = data; },
      err => console.error(err),
    //  () => // console.log('done loading brand_types')
    );
  }




  getFormUserLevel(level) {
    this._demoService.getUserLevel(level).subscribe(
      data => {
        this.user_level = data;
        // console.log(data);
      },
      err => console.error(err),
      // () => console.log('done loading User Levels')
    );
  }


  // modal

  // MODAL
  // start of modal windows service as a template
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  // MODAL view a component
  openModalEditCompanyComponent(brand_id) {
    const initialState = {
      list: [
        'Open a modal with component',
        'Pass your data',
        'Do something else',
        '...'
      ],
      title: 'Modal with component',
      trace_id: 1010,
      brand_id: brand_id
    };
    this.bsModalRef = this.modalService.show(CompanyEditComponent, { initialState });
    this.bsModalRef.content.closeBtnName = 'Close';
  }



  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
  };


  // to router navigate back
  public goBack() {
    this._location.back();
  }



  // Setup the SyncFusion GRID


  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
    }
    if (args.item.id === 'Grid_pdfexport') { // 'Grid_pdfexport' -> Grid component id + _ + toolbar item name
      this.grid.pdfExport();
  }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    const job_status = 'job_status';
    if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
    }
  }



  brandView(brand_id) {
    this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
  }

  brandEdit(brand_id) {
    this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
  }


  jobLink(job_id) {
    this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
  }

  jobView(job_id) {
    this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  }

  subjectEdit(subject_id) {
    this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  }



  refreshGrid() { // refresh the databutton
    //this.mapJobTableLive();
    this.getBrandJobsTableData(this.brand_id);
    this.grid.refresh();
  };





  getBrandJobsTableData(brand_id) {
    this._demoService.getBrandJobsTableData(brand_id).subscribe(
      data => {
        this.subjects_urgent = data;
        this.open_jobs_count = this.subjects_urgent.length;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


  // End Grid Items and Setup


  userView(user_id) {
    this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
  }

  userEdit(user_id) {
    this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
  }

}